import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-2035">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2036">
          {label}
        </label>}
      <input className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#7CB342] focus:border-transparent ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-2037" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-2038">{error}</p>}
    </div>;
}